import React from "react";
import OPOnlineIframe from "../../../iframe-component/operation-online/OPOnIframe";

const AddOnlineEmployee = ({ path }) => {
  return <OPOnlineIframe path="/online-pay/employee/create" statePath={path} />;
};

export default React.memo(AddOnlineEmployee);
